export default function CharityOption() {
  return (
    <section className="py-16 lg:py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Your Choice: Keep It or Give It
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            The Dog Tag Discount is yours — $300 off your purchase. But if you'd rather pay it forward,
            we'll donate it to Oregon Dog Rescue on your behalf.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 rounded-full px-4 py-2 mb-6">
              <i className="ri-hand-heart-line"></i>
              <span className="text-sm font-semibold">Give Back Option</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Your Discount, Your Choice
            </h2>
            
            <p className="text-xl text-slate-600 mb-6 leading-relaxed">
              We believe in honoring your service in the way that matters most to you. That's why we give you two options with your $300 military discount.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-slate-900 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-line text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    Option 1: Take the Discount
                  </h3>
                  <p className="text-slate-600">
                    Apply the full $300 directly to your vehicle purchase. Simple, straightforward savings on your next car.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-emerald-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-line text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    Option 2: Donate to Charity
                  </h3>
                  <p className="text-slate-600">
                    Direct the full $300 to any registered 501(c)(3) charity of your choosing. We'll make the donation in your name and provide documentation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/bfd11959acd989d402ef45606940c845.jpg"
                alt="Military family with new vehicle"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-heart-fill text-red-500 text-2xl"></i>
                <span className="font-bold text-slate-900">Your Impact</span>
              </div>
              <p className="text-sm text-slate-600">
                Whether you take the discount or donate it, you're making a difference in your community.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-slate-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
            Popular Charity Choices
          </h3>
          <p className="text-slate-600 text-center mb-8 max-w-2xl mx-auto">
            While you can choose any registered charity, here are some organizations our military customers have supported:
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-6 text-center">
              <i className="ri-shield-cross-line text-3xl text-red-600 mb-3"></i>
              <h4 className="font-bold text-slate-900 mb-2">Veteran Support</h4>
              <p className="text-sm text-slate-600">Wounded Warrior Project, DAV, Fisher House</p>
            </div>
            <div className="bg-white rounded-lg p-6 text-center">
              <i className="ri-heart-pulse-line text-3xl text-emerald-600 mb-3"></i>
              <h4 className="font-bold text-slate-900 mb-2">Animal Welfare</h4>
              <p className="text-sm text-slate-600">Oregon Dog Rescue, local shelters, K9 veterans</p>
            </div>
            <div className="bg-white rounded-lg p-6 text-center">
              <i className="ri-community-line text-3xl text-blue-600 mb-3"></i>
              <h4 className="font-bold text-slate-900 mb-2">Local Community</h4>
              <p className="text-sm text-slate-600">Food banks, youth programs, homeless services</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}